module.exports = __webpack_public_path__ + "static/media/19-2.676830c6.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/imagenes/19-2.jpeg
// module id = 106
// module chunks = 0